var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 20,
    height: 20,
    transform: "translate(4.291 4.29)",
    fill: "#012169",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(-4.291 -4.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_638",
    "data-name": "Mask Group 638",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "podcast",
    d: "M11.7,19.085c-.2.743-.96.916-1.7.916s-1.5-.173-1.7-.916A28.464,28.464,0,0,1,7.5,13.9c0-1.373,1.216-1.709,2.5-1.709s2.5.336,2.5,1.709a28.492,28.492,0,0,1-.8,5.188ZM5.625,9.063a4.375,4.375,0,1,1,7.653,2.9.234.234,0,0,0-.019.29,2.663,2.663,0,0,1,.427,1,.235.235,0,0,0,.391.125,5.938,5.938,0,1,0-8.155,0,.235.235,0,0,0,.391-.125,2.662,2.662,0,0,1,.427-1,.234.234,0,0,0-.019-.29A4.343,4.343,0,0,1,5.625,9.063ZM10.02,0A9.22,9.22,0,0,0,6.35,17.686a.234.234,0,0,0,.322-.258q-.119-.654-.216-1.311a.235.235,0,0,0-.121-.172,7.656,7.656,0,1,1,7.327,0,.235.235,0,0,0-.121.172q-.1.657-.216,1.311a.234.234,0,0,0,.322.258A9.22,9.22,0,0,0,10.02,0ZM10,6.25a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,10,6.25Z",
    transform: "translate(4.291 4.29)",
    fill: "#012169"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare1);
export default __webpack_public_path__ + "static/media/share1.7508163d26243cf1370f04a02e299c7f.svg";
export { ForwardRef as ReactComponent };